export default __webpack_public_path__ + "static/video-8919aaf24e27fe85c6972a9c1928b8cd.mp4";